import {Component, OnInit, ChangeDetectorRef} from '@angular/core';
import {UserService} from "../user.service";
import {LayoutService} from "../../layout/layout.service";

import { SessionSetting, AppHttp } from '../../../app.service';
import { Pslistener } from "app/pf.core/listener/Pslistener";

@Component({

  selector: 'sa-login-info',
  templateUrl: './login-info.component.html',
})
export class LoginInfoComponent implements OnInit {

  user:any;

  constructor(
    private userService: UserService,
    private cd : ChangeDetectorRef,
    private layoutService: LayoutService,private http: AppHttp) {
  }

  ngOnInit() {
    //www this.userService.getLoginInfo().subscribe(user => {
    //  this.user = user
    //})
    this.user = {username: SessionSetting.getUser().UserName, picture: 'assets/img/avatars/male.png'};
    Pslistener.appUserEdit.dialog.finish.subscribe(v => {
      this.user.username = v.USER_DISPLAY_NAME;
      this.cd.detectChanges();
    });
  }

  toggleShortcut() {
    let uId = SessionSetting.getUser().UserID;
    uId = encodeURIComponent(uId).replace(/\./g, '_ddddd_');
    this.http
      .get('main', `/main/user/users/${uId}`, null)
      .then(o => {
        console.log(o.data)
        Pslistener.appUserEdit.dialog.show('main', o.data, "appEdit");
      });
    this.layoutService.onShortcutToggle();
  }

}



// WEBPACK FOOTER //
// C:/wxj/LicAuth/05開発/LicAuth.angularjs/src/app/shared/user/login-info/login-info.component.ts